module.exports = __webpack_public_path__ + "media/images/riders/small/LARS_FORSTER-75b9918395abb441de24173c4a5ce570.png";